import React from 'react';
import { Edit } from 'react-admin';
import { getTransform } from '../rateSettingsTransform';
import RateSettingsForm from '../shared/rate-settings-form/RateSettingsForm';

const AgencyLocationRateSettingEdit = () => (
  <Edit
    mutationMode="pessimistic"
    transform={getTransform(['agency_id', 'location_id'], 'agency_location_rate_setting')}
  >
    <RateSettingsForm settingsField="agency_location_rate_setting" />
  </Edit>
);

export default AgencyLocationRateSettingEdit;
